module.exports = __webpack_public_path__ + "static/media/Icon 3.5049cd20.png";